// frontend_react/src/components/restaurant/Item.jsx

import React from 'react';

function Item({
  product,
  ajouterAuPanier,
  supprimerDuPanier,
  prepared,
  setModalProduct,
  setFieldValues,
}) {
  const quantity = Number(product?.quantite ?? 0);
  const unitPrice = Number(product?.price ?? 0);
  const totalPrice = ((unitPrice * quantity) / 100).toFixed(2);

  return (
    <li className={`cart-item ${prepared ? "cart-item--prepared" : ""}`}>
      <div className="qty-control">
        {!prepared && (
          <button className="qty-btn" onClick={() => supprimerDuPanier(product)}>
            −
          </button>
        )}

        <span className="qty-value">{quantity}</span>

        <button className="qty-btn" onClick={() => ajouterAuPanier(product)}>
          +
        </button>
      </div>

      <span className="cart-item__name">{product?.name}</span>

      {!prepared && setModalProduct && (
        <button
          className="btn-icon"
          onClick={() => {
            setModalProduct(product);
            setFieldValues({ ...(product?.filled_fields || {}) });
          }}
          title="Modifier"
        >
          ✎
        </button>
      )}

      <span className="cart-item__price">{totalPrice} €</span>
    </li>
  );
}

export default Item;